<template>
    <div>
        <!-- 搜索框 -->
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow" :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm" :table-load-event="getRefundList"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">提现单</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch" :table-load-event="getRefundList" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import {
    refundStatusFormat
} from './refund-type.js';
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import {
    dateTimeRender
} from "@/libs/tableRowTimeRender";
import {
    getRefundList,
    approveRefund,
    downloadApplyTable
} from "@/api/modules/finance-management/refund";
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: "RefundList",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            show: false,
            mainTable: {
                columns: [{
                    title: "行号",
                    type: "index",
                    width: 60,
                    align: "center"
                },
                {
                    title: "提现单号",
                    key: "refundNo",
                    align: "center"
                },
                {
                    title: "会员号",
                    key: "userName",
                    align: "center"
                },
                {
                    title: "会员名称",
                    key: "userPersonName",
                    align: "center"
                },
                {
                    title: "手机号码",
                    key: "userPhone",
                    align: "center"
                },
                {
                    title: "提现金额",
                    key: "refundAmount",
                    align: "center"
                },
                {
                    title: "提现原因",
                    key: "remark",
                    align: "center"
                },
                {
                    title: "客户余额",
                    key: "memberFundBalance",
                    align: "center"
                },
                {
                    title: "冻结金额",
                    key: "freezeMoney",
                    align: "center"
                },
                {
                    title: "可用金额",
                    key: "availableAmount",
                    align: "center"
                },
                {
                    title: "发起时间",
                    key: "createTime",
                    width: 120,
                    align: "center",
                    render: (h, params) =>
                        dateTimeRender(h, params.row.createTime)
                },
                {
                    title: '提现状态',
                    key: 'refundStatus',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('span', {}, refundStatusFormat(params.row.refundStatus))
                        ]);
                    }
                },
                {
						    title: '提现申请表',
						    key: '',
						    align: 'center',
						    width: 90,
						    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.downloadApplyTable(params.row);
                                    }
                                }
                            }, '下载')
                        ]);
						    }
                },
                {
                    title: "经办人",
                    key: "approvalUser",
                    align: "center"
                },
                {
                    title: '操作',
                    key: 'approvalAction',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', {}, '');
                        // if (params.row.refundStatus == 0) {
                        //     return h('div', [
                        //         h('Button', {
                        //             props: {
                        //                 type: 'text',
                        //                 size: 'small',
                        //                 shape: 'circle'
                        //             },
                        //             style: {},
                        //             on: {
                        //                 click: () => {
                        //                     this.onPass(params.row);
                        //                 }
                        //             }
                        //         }, '通过'),
                        //         h('Button', {
                        //             props: {
                        //                 type: 'text',
                        //                 size: 'small',
                        //                 shape: 'circle'
                        //             },
                        //             style: {},
                        //             on: {
                        //                 click: () => {
                        //                     this.onFail(params.row);
                        //                 }
                        //             }
                        //         }, '不通过')
                        //     ]);
                        // }
                    }
                }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [{
                    label: "提现单号",
                    type: "Input",
                    value: "",
                    name: "refundNo",
                    sql: "like"
                },
                {
                    label: "会员号",
                    type: "Input",
                    value: "",
                    name: "refundUser.userName",
                    sql: "like"
                },
                {
                    label: "会员名称",
                    type: "Input",
                    value: "",
                    name: "refundUser.userPersonName",
                    sql: "like"
                },
                {
                    label: "手机号码",
                    type: "Input",
                    value: "",
                    name: "refundUser.userPhone",
                    sql: "like"
                }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            refundSource: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.refundSource = [];
            this.refundSource.push({
                val: 0,
                label: refundStatusFormat(0)
            });
            this.refundSource.push({
                val: 1,
                label: refundStatusFormat(1)
            });
            this.refundSource.push({
                val: 2,
                label: refundStatusFormat(2)
            });
            this.refundSource.push({
                val: 3,
                label: refundStatusFormat(3)
            });

            this.getRefundList();
        },
        onCheckRefund(row) {
            this.show = true;
        },
        getRefundList(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getRefundList(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        res.data.filterRecordCount
                    );
                }
            });
        },
        approveRefund(id, refundStatus) {
            approveRefund({
                id: id,
                refundStatus: refundStatus
            }).then(res => {
                if (res.code === 0) {
                    this.getRefundList(true);
                }
            });
        },
        onPass(refund) {
            this.approveRefund(refund.id, 1);
        },
        onFail(refund) {
            this.approveRefund(refund.id, 2);
        },
        downloadApplyTable(refund){
            downloadApplyTable({
				    id: refund.id
            }).then(res => {
				    if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.url;
                    this.$downLoadFile(url);
				    }
            });
            this.mainTable.loading = false;
        }
    }
};
</script>

<style>
</style>
